/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MfaMethod } from './MfaMethod';
import {
    MfaMethodFromJSON,
    MfaMethodFromJSONTyped,
    MfaMethodToJSON,
    MfaMethodToJSONTyped,
} from './MfaMethod';

/**
 * 
 * @export
 * @interface OrganizationMfaSettings
 */
export interface OrganizationMfaSettings {
    /**
     * 
     */
    mfa_enabled: boolean;
    /**
     * 
     */
    mfa_allowed_methods: Array<MfaMethod>;
}

/**
 * Check if a given object implements the OrganizationMfaSettings interface.
 */
export function instanceOfOrganizationMfaSettings(value: object): value is OrganizationMfaSettings {
    if (!('mfa_enabled' in value) || value['mfa_enabled'] === undefined) return false;
    if (!('mfa_allowed_methods' in value) || value['mfa_allowed_methods'] === undefined) return false;
    return true;
}

export function OrganizationMfaSettingsFromJSON(json: any): OrganizationMfaSettings {
    return OrganizationMfaSettingsFromJSONTyped(json, false);
}

export function OrganizationMfaSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationMfaSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'mfa_enabled': json['mfa_enabled'],
        'mfa_allowed_methods': ((json['mfa_allowed_methods'] as Array<any>).map(MfaMethodFromJSON)),
    };
}

export function OrganizationMfaSettingsToJSON(json: any): OrganizationMfaSettings {
    return OrganizationMfaSettingsToJSONTyped(json, false);
}

export function OrganizationMfaSettingsToJSONTyped(value?: OrganizationMfaSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mfa_enabled': value['mfa_enabled'],
        'mfa_allowed_methods': ((value['mfa_allowed_methods'] as Array<any>).map(MfaMethodToJSON)),
    };
}

